import api from '@/sui/api/api'
import delay from '@/sui/api/delay'
import results from '@/sui/data/results'
import assert from '@/sui/tools/assert'

let module = null

const remote = true
if (remote) {
  module = {
    loadResult (request) {
      return api.post('/incidence/get', request)
    },

    loadStatistics (request) {
      return api.post('/popstat/get', request)
    }
  }
} else {
  module = {
    loadResult (request) {
      return delay(1000)({ data: { v: generateResult() } })
    },

    loadStatistics (r) {
      return delay(200)({ data: { v: generateStats(r.spe, r.den, r.ent) } })
    }
  }
}

function randi (max) {
  return Math.floor(Math.random() * (max + 1))
}

function shuffleArray (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = randi(i)
    const temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
}

function testP (p) {
  return Math.random() <= p
}

function generateResult () {
  const proba = {
    jh: { all: 1 },
    sea: { adDia: 1, pedDia: 1, all: 0 },
    mon: { adDia: 0.4, pedDia: 0.1, all: 0 },
    adm: { all: 1, adHad: 0, pedHad: 0 },
    pat: {
      adRea: 1,
      pedRea: 1,
      adMed: 0.05,
      neoRea: 1,
      pedMed: 0.05,
      neoMed: 0.05,
      mixRea: 1,
      all: 0
    },
    kt: {
      adRea: 0.95,
      pedRea: 0.95,
      adMed: 0.05,
      neoRea: 0.95,
      pedMed: 0.05,
      neoMed: 0.05,
      mixRea: 0.95,
      all: 0
    },
    test: function (spe, test) {
      const p = this[test]
      assert.notNull(p)
      const v = p[spe] == null ? p.all : p[spe]
      return testP(v)
    }
  }

  const services = []
  for (let s in results.specialities('2020')) {
    services.push(s)
  }
  const count = 1 + randi(services.length - 1)
  shuffleArray(services)

  const etabs = []
  for (let t in results.establishments) {
    etabs.push(t)
  }
  shuffleArray(etabs)

  const result = { t: etabs[0], i: [] }
  for (let i = 0; i !== count; ++i) {
    const spe = services[i]
    const ufs = ['__all__']
    if (testP(0.4)) {
      ufs.push(`${spe} UF1`)
      if (testP(0.2)) {
        ufs.push(`${spe} UF2`)
        ufs.push(`${spe} UF3`)
        ufs.push(`${spe} UF4`)
      }
    }
    for (let d in results.denominators) {
      if (proba.test(spe, d)) {
        for (let e in results.entrances) {
          ufs.forEach(
            uf => {
              result.i.push(generateInc(d, e, spe, uf))
            }
          )
        }
      }
    }
  }
  return result
}

function generateStats (spe, den, ent) {
  const result = []

  for (let et in results.establishments) {
    const count = testP(0.6) ? randi(120) : randi(20)
    const pts = []
    let sum = 0
    let min = 100000
    let max = 0
    for (let i = 0; i !== count; ++i) {
      let value
      if (testP(0.3)) {
        value = 0
      } else if (testP(0.6)) {
        value = Math.random()
      } else {
        value = Math.random() * 25
      }
      pts.push(value)
      sum += value
      if (value > max) {
        max = value
      }
      if (value < min) {
        min = value
      }
    }
    pts.sort((f, s) => f - s)

    const med = count > 0 ? pts[Math.floor((count - 1) / 2)] : 0
    result.push({
      t: et,
      spe: spe,
      den: den,
      ent: ent,
      pop: pts,
      s: {
        med: count > 0 ? med : 0,
        mean: sum / count,
        min: min,
        max: max,
        n: count
      }
    })
  }
  return result
}

function generateInc (d, e, s, u) {
  const inc = testP(0.1) ? randi(12) : testP(0.1) ? 20 + randi(50) : Math.random()
  const qua = inc > 25 ? 3 : inc > 1 ? 2 : 0
  return {
    den: d,
    ent: e,
    spe: s,
    uf: u,
    inc: inc,
    qua: qua,
    mean: (Math.random() * 0.2 + 0.3)
  }
}

export default module
